import { createSelector } from "@reduxjs/toolkit";

const selectWipNotification = (state) => state.wipNotification;

export const selectWipNotifications = createSelector(
  [selectWipNotification],
  (wipNotification) =>
    [...(wipNotification?.notifications || [])]?.sort((a, b) => {
      // Sort by isRead: false first, then true
      if (a.isRead === b.isRead) {
        // Then sort by createdAt (newest first)
        return new Date(b.createdAt) - new Date(a.createdAt);
      }
      return a.isRead ? 1 : -1;
    })
);

export const selectWipNotificationCount = createSelector(
  [selectWipNotification],
  (wipNotification) => wipNotification.unreadCount || 0
);

export const selectWipNotificationLoading = createSelector(
  [selectWipNotification],
  (wipNotification) => wipNotification.loading || false
);

export const selectWipNotificationPagination = createSelector(
  [selectWipNotification],
  (wipNotification) => wipNotification.pagination || {}
);

